import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const StyledAnchor = styled.a`
  cursor: pointer;
`;

export const touchOptimizedStyles = css`
  user-select: none; /* Prevent text selection */
  -webkit-tap-highlight-color: transparent; /* Remove highlight */
`;
